import { render, staticRenderFns } from "./MonitoringProspectionDashboard.vue?vue&type=template&id=601a770d&"
import script from "./MonitoringProspectionDashboard.vue?vue&type=script&lang=js&"
export * from "./MonitoringProspectionDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports